import { render } from "./etDesignTable.vue?vue&type=template&id=cf85e084"
import script from "./etDesignTable.vue?vue&type=script&lang=js"
export * from "./etDesignTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__